var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCharging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "#B5B8C5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1139 13.7087V1.72876C16.1139 1.25455 15.7324 0.873047 15.2582 0.873047H3.56346C1.67377 0.873047 0.140625 2.40619 0.140625 4.29588V15.7053C0.140625 17.595 1.67377 19.1282 3.56346 19.1282H15.2582C15.7324 19.1282 16.1139 18.7467 16.1139 18.2725V17.702C16.1139 17.4346 15.9891 17.1921 15.7965 17.0353C15.6468 16.4862 15.6468 14.9209 15.7965 14.3719C15.9891 14.2185 16.1139 13.9761 16.1139 13.7087ZM4.70441 5.65076C4.70441 5.5331 4.80067 5.43683 4.91833 5.43683H12.4771C12.5948 5.43683 12.691 5.5331 12.691 5.65076V6.36385C12.691 6.48151 12.5948 6.57777 12.4771 6.57777H4.91833C4.80067 6.57777 4.70441 6.48151 4.70441 6.36385V5.65076ZM4.70441 7.93265C4.70441 7.81499 4.80067 7.71872 4.91833 7.71872H12.4771C12.5948 7.71872 12.691 7.81499 12.691 7.93265V8.64574C12.691 8.7634 12.5948 8.85966 12.4771 8.85966H4.91833C4.80067 8.85966 4.70441 8.7634 4.70441 8.64574V7.93265ZM13.7393 16.8463H3.56346C2.93238 16.8463 2.42252 16.3364 2.42252 15.7053C2.42252 15.0778 2.93594 14.5644 3.56346 14.5644H13.7393C13.6715 15.1741 13.6715 16.2366 13.7393 16.8463Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharging);
export default __webpack_public_path__ + "static/media/charging.15f6ef568c2bfb8527572e6ba9ab6c7e.svg";
export { ForwardRef as ReactComponent };